import { Toolbar } from "../../../../../_metronic/layout/components/header/Toolbar";

const DashboardToolbar = () => {
  return <Toolbar></Toolbar>;
};

export default DashboardToolbar;
